






















import Vue from 'vue';

import { userStorage } from '@/db/storage';

import Dropdown from "@/components/app/dropdown.vue";
import Modal    from "@/components/Modal.vue";

export default Vue.extend({
    data() {
        return {
            showImportModal: false,
        }
    },
    components: {
        "dropdown-menu": Dropdown,
        Modal,
    },
    methods: {
        dropOptions() {
            return [
                {
                name: "Import Deck",
                icon: "cloud_upload",
                id: "upload",
                action: () => (this.showImportModal = true)
                },
            ];
        },
        dropSelected(payload) {
            payload.action();
        },
        importDeck() {
            console.log("Importing...");
            try {
                const file      = (<HTMLInputElement>document.getElementById('btnFiles')).files[0];
                const ref       = userStorage.child(`${this.currentUser.uid}/deckImports/${file.name}`);
                const task      = ref.put(file);
                task.on('state_changed', 
                    (progress) => {
                        // Update progress bar>
                    },
                    (err) => {
                        // There was an error!
                        this.uploadError(err);
                    },
                    () => {
                        // Complete!
                        this.uploadSuccess();
                    }
                )
            } catch (error) {
                this.uploadError(error);
            }
        },
        uploadError(err) {
            console.error(err);
            this.$toast.open({
                message: 'There was an error with the upload.  Please try again.',
                type: 'error',
                duration: 3000,
                position: 'top-right'
            });
            this.showImportModal = false;
        },
        uploadSuccess() {
            this.$toast.open({
                message: 'Upload complete!  Deck will be imported shortly.',
                type: 'success',
                duration: 3000,
                position: 'top-right'
            });
            this.showImportModal = false;
        }
    }
})
